/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Status_TextInputs */

const en_a11y_statement_status_text = /** @type {(inputs: A11y_Statement_Status_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This web application is <strong>partially compliant</strong> with EN 301 549 / WCAG 2.2 Level AA.`)
};

const de_a11y_statement_status_text = /** @type {(inputs: A11y_Statement_Status_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Webanwendung ist <strong>teilweise vereinbar</strong> mit EN 301 549 / WCAG 2.2 Level AA.`)
};

const fr_a11y_statement_status_text = /** @type {(inputs: A11y_Statement_Status_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette application web est <strong>partiellement conforme</strong> a EN 301 549 / WCAG 2.2 niveau AA.`)
};

const es_a11y_statement_status_text = /** @type {(inputs: A11y_Statement_Status_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta aplicacion web es <strong>parcialmente conforme</strong> con EN 301 549 / WCAG 2.2 nivel AA.`)
};

const it_a11y_statement_status_text = /** @type {(inputs: A11y_Statement_Status_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa applicazione web e <strong>parzialmente conforme</strong> a EN 301 549 / WCAG 2.2 livello AA.`)
};

const nl_a11y_statement_status_text = /** @type {(inputs: A11y_Statement_Status_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze webapplicatie is <strong>gedeeltelijk conform</strong> met EN 301 549 / WCAG 2.2 niveau AA.`)
};

const pl_a11y_statement_status_text = /** @type {(inputs: A11y_Statement_Status_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta aplikacja internetowa jest <strong>czesciowo zgodna</strong> z EN 301 549 / WCAG 2.2 poziom AA.`)
};

const fi_a11y_statement_status_text = /** @type {(inputs: A11y_Statement_Status_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä verkkosovellus on <strong>osittain yhdenmukainen</strong> EN 301 549 / WCAG 2.2 taso AA:n kanssa.`)
};

const da_a11y_statement_status_text = /** @type {(inputs: A11y_Statement_Status_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne webapplikation er <strong>delvist i overensstemmelse</strong> med EN 301 549 / WCAG 2.2 niveau AA.`)
};

const sv_a11y_statement_status_text = /** @type {(inputs: A11y_Statement_Status_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denna webbapplikation ar <strong>delvis overensstammande</strong> med EN 301 549 / WCAG 2.2 niva AA.`)
};

/**
* | output |
* | --- |
* | "This web application is <strong>partially compliant</strong> with EN 301 549 / WCAG 2.2 Level AA." |
*
* @param {A11y_Statement_Status_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_status_text = /** @type {((inputs?: A11y_Statement_Status_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Status_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_status_text(inputs)
	if (locale === "fr") return fr_a11y_statement_status_text(inputs)
	if (locale === "es") return es_a11y_statement_status_text(inputs)
	if (locale === "it") return it_a11y_statement_status_text(inputs)
	if (locale === "nl") return nl_a11y_statement_status_text(inputs)
	if (locale === "pl") return pl_a11y_statement_status_text(inputs)
	if (locale === "fi") return fi_a11y_statement_status_text(inputs)
	if (locale === "da") return da_a11y_statement_status_text(inputs)
	if (locale === "sv") return sv_a11y_statement_status_text(inputs)
	return en_a11y_statement_status_text(inputs)
});